import component from './CugBadge';

export default component;
